import assetAdvancedFilters from '../modals/advancedFilters/lan/es';
import createEditAsset from '../modals/createEditAsset/lan/es';
import deleteAsset from '../modals/deleteAsset/lan/es';

export default {
    manage_asset_unit: "Unidad",
    manage_asset_assetType: "Tipo de Activo",
    manage_asset_assetSubType: "Subtipo de Activo",
    manage_asset_externalID: "ID Externo",
    manage_asset_vin: "VIN",
    manage_asset_label: "Etiqueta",
    manage_asset_inspectionDeviceType: "Tipo de Dispositivo de Inspección",
    manage_asset_tags: "Etiquetas",
    manage_asset_status: "Estado",
    manage_asset_active: "Activo",
    manage_asset_inactive: "Inactivo",
    manage_asset_search_table: "Búsqueda por etiqueta, VIN, tipo de activo y subtipo de activo",
    ...assetAdvancedFilters,
    ...createEditAsset,
    ...deleteAsset,
}